import { Sku } from 'base/types/RecommendationCropwise';
import field_area from '../../../../assets/icons/field_area.svg';
import qr_code from '../../../../assets/icons/qr_code.svg';
import { useTranslation } from 'react-i18next';
import {
  IconText,
  ProductContainer,
  CircleContainer,
  InnerCircle,
  ProductNameText,
  IconContainer,
  ProductContainerRow,
  ProductCards,
  TopRatedProduct,
  ProductFieldDetails,
} from './RecommendationProductsCard.styles';

export interface IProps {
  index: number;
  id?: string;
  color?: string;
  product_name: string;
  commercial_name: string;
  applied_area?: number;
  quantity?: number;
  handleOnClick?: (productName: string) => void;
  isProductSelected?: boolean;
  isMobile?: boolean;
  size?: number;
  sku?: Sku;
  isDDG?: boolean;
  isAlternateProduct?: boolean;
}

const RecommendationProductsCard = ({
  index,
  id,
  color,
  product_name,
  commercial_name,
  applied_area,
  quantity,
  sku,
  handleOnClick,
  isProductSelected,
  isMobile,
  size,
  isDDG,
  isAlternateProduct,
}: IProps) => {
  const [t] = useTranslation();

  // Format numbers for better readability (e.g., 50000 -> 50K, 1000000 -> 1M)
  const formatNumber = (num: number): string => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1).replace(/\.0$/, '') + t('m');
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1).replace(/\.0$/, '') + t('K');
    }
    return num.toString();
  };

  return (
    <ProductCards onClick={() => !isAlternateProduct && handleOnClick?.(product_name)}>
      <ProductContainer size={size} id={id} isProductSelected={isProductSelected}>
        {isDDG && index === 0 && <TopRatedProduct>{t('Top Rated Product')}</TopRatedProduct>}
        {isDDG && index !== 0 && (
          <TopRatedProduct isAlternateProduct>{t('Alternative Product')}</TopRatedProduct>
        )}
        {!isDDG && isAlternateProduct && (
          <TopRatedProduct isAlternateProduct>{t('Alternative Product')}</TopRatedProduct>
        )}
        <ProductContainerRow>
          <CircleContainer color={color}>
            <InnerCircle color={color} />
          </CircleContainer>
          <ProductNameText>{commercial_name}</ProductNameText>
        </ProductContainerRow>
        <ProductFieldDetails isAlternateProduct={isAlternateProduct}>
          {(applied_area || quantity) && (
            <ProductContainerRow>
              <IconContainer>
                <img src={field_area} alt="icon" />
              </IconContainer>
              <IconText>
                {applied_area?.toFixed(2) && `${applied_area.toFixed(2)} ${t('ha')}`}
                {quantity?.toFixed(2) && ` • ${quantity} ${quantity === 1 ? t('Bag') : t('Bags')}`}
                {sku?.bagSize && ` (${formatNumber(sku.bagSize)} ${t('Seeds/bag')})`}
              </IconText>
            </ProductContainerRow>
          )}
        </ProductFieldDetails>
      </ProductContainer>
    </ProductCards>
  );
};

export default RecommendationProductsCard;
